
import React, { useState, useEffect, memo } from 'react';
import { Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';

const OwnerDetailsPdf = memo((props) => { 
   
    const [page, setPage] = useState(0);
    const [ownerDetailsData, setOwnerDetailsData] = useState({});

    useEffect(() => { 
        if (props && props.data) {
            setOwnerDetailsData(props.data); 
        }
    }, [props && props.data]);


    return (
        <div className='pdf-export-table'>
            <Table className='table-design'>
                <TableHead>
                     <TableRow>
                     
                        <TableCell>Title</TableCell>
                        <TableCell>First Name</TableCell>
                        <TableCell>Last Name</TableCell>
                        <TableCell>Company Name</TableCell>
                        <TableCell>Company Phone</TableCell>
                        <TableCell>Company Email</TableCell>
                        <TableCell>Website</TableCell>
                        <TableCell>Address Line 1</TableCell>
                        <TableCell>Address Line 2</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>State</TableCell>
                        <TableCell>Fax</TableCell>
                        <TableCell>Toll-free</TableCell>
                        <TableCell>Country</TableCell>
                        <TableCell>Zip Code</TableCell>
                    </TableRow>
                    </TableHead> 
                    <TableBody>

                        {ownerDetailsData && 
                            ownerDetailsData.length > 0 ? (
                                ownerDetailsData.map((data) => (
                            <TableRow>
                                        <TableCell>{data.title !== null ? data.title : "-"}</TableCell>
                                        <TableCell>{data.firstname !== null ? data.firstname : "-"}</TableCell>
                                        <TableCell>{data.lastname !== null ? data.lastname : "-"}</TableCell>
                                        <TableCell>{data.companyname !== null ? data.companyname : "-"}</TableCell>
                                        <TableCell>{data.companyPhone !== null ? data.companyPhone : "-"}</TableCell>
                                        <TableCell>{data.companyEmail !== null ? data.companyEmail : "-"}</TableCell>
                                        <TableCell>{data.website !== null ? data.website : "-"}</TableCell>
                                        <TableCell>{data.streetaddress1 !== null ? data.streetaddress1 : "-"}</TableCell>
                                        <TableCell>{data.streetaddress2 !== null ? data.streetaddress2 : "-"}</TableCell>
                                        <TableCell>{data.city !== null ? data.city : "-"}</TableCell>
                                        <TableCell>{data.state !== null ? data.state : "-"}</TableCell>
                                        <TableCell>{data.country !== null ? data.country : "-"}</TableCell>
                                        <TableCell>{data.fax !== null ? data.fax : "-"}</TableCell>
                                        <TableCell>{data.tollfree !== null ? data.tollfree : "-"}</TableCell>
                                        <TableCell>{data.zipcode !== null ? data.zipcode : "-"}</TableCell>
                                    </TableRow>
                                ))
                            ) 
                            : (
                                <TableRow>
                                  <TableCell colSpan={7} style={{ textAlign: "center" }} className="store-no-data">No records found</TableCell>
                                </TableRow>
                              )
                        }

                    </TableBody>   
               
            </Table>
        </div>
    )
});

export default OwnerDetailsPdf;